import React, { Component } from "react";

export default class OfferPage extends Component {
  render() {
    return (
      <div>
        <h1>Hello from Offer page</h1>
      </div>
    );
  }
}
